import { appConfig } from '@config';

/** enum of filing status names from BE */
export const STATUS_NAME = {
  COMPLIANCE_ERRORS: 'compliance_errors',
  COMPLIANCE_WARNINGS: 'compliance_warnings',
  CANCELLED: 'cancelled',
  GET_STARTED: 'get_started',
  UPLOAD_FAILED: 'upload_failed',
  PROCESSING: 'processing',
  PROCESSED: 'processed',
  PREPARING: 'preparing',
  REJECTED: 'rejected',
  READY_FILE: 'ready_file',
  READY_SEND: 'ready_to_send',
  FILED: 'filed',
  AWAITING_REVIEW: 'awaiting_review',
  PROCESSING_ERRORS: 'processing_errors',
  VAT_GLOBAL_REVIEW: 'vat_global_review',
  DRAFT_APPROVAL: 'client_approval_pending', // TODO: Remove this duplication
  DATA_REJECTED: 'data_rejected',
  DRAFT_REJECTED: 'filing_rejected',
  PAYMENTS_DUE: 'payment_due',
  PAYMENT_CLEARANCE: 'payment_clearance',
  SENT_FOR_FILING: 'sent_for_filing',
  SENT_FOR_REVIEW: 'sent_for_review',
  CLIENT_APPROVAL_PENDING: 'client_approval_pending',
};

// Add different response statuses here which we retrieve from response.data
export const DATA_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const FILING_STATUS = {
  compliance_errors: {
    className: 'error',
    text: {
      translation: 'global.status.compliance-errors',
      defaultMessage: 'Compliance Errors',
    },
    button: {
      translation: 'global.status.compliance-errors.button',
      defaultMessage: 'Troubleshoot',
    },
  },
  compliance_warnings: {
    className: 'warnings',
    text: {
      translation: 'global.status.compliance-warnings',
      defaultMessage: 'Compliance Warnings',
    },
    button: {
      translation: 'global.status.compliance-errors.button',
      defaultMessage: 'Troubleshoot',
    },
  },
  get_started: {
    className: 'grey',
    text: {
      translation: 'global.status.get-started',
      defaultMessage: 'Get Started',
    },
    button: {
      translation: 'global.status.get-started.button',
      defaultMessage: 'Get Started',
    },
  },
  cancelled: {
    className: 'grey',
    text: {
      translation: 'global.status.cancelled',
      defaultMessage: 'Cancelled',
    },
    button: {
      translation: 'global.status.cancelled.button',
      defaultMessage: 'Cancelled',
    },
  },
  upload_failed: {
    className: 'error',
    text: {
      translation: 'global.status.upload-failed',
      defaultMessage: 'Upload failed',
    },
    button: {
      translation: 'global.status.upload-failed.button',
      defaultMessage: 'Try Again',
    },
  },
  processing: {
    className: 'grey',
    text: {
      translation: 'global.status.processing',
      defaultMessage: 'Processing',
    },
    button: {
      translation: 'global.status.processing.button',
      defaultMessage: 'View',
    },
  },
  processed: {
    className: 'success',
    text: {
      translation: 'global.status.processed',
      defaultMessage: 'Processed',
    },
    button: {
      translation: 'global.status.processed.button',
      defaultMessage: 'Generate Draft',
    },
  },
  ready_to_send: {
    className: 'success',
    text: {
      translation: 'global.status.ready-to-send',
      defaultMessage: 'Ready to Send',
    },
    button: {
      translation: 'global.status.filed.button',
      defaultMessage: 'View',
    },
  },
  vat_global_review: {
    className: 'grey',
    text: {
      translation: 'global.status.company-review',
      defaultMessage: `${appConfig.company.name} Review`,
    },
    button: {
      translation: 'global.status.company-review.button',
      defaultMessage: 'View',
    },
  },
  preparing: {
    className: 'grey',
    text: {
      translation: 'global.status.preparing',
      defaultMessage: 'Preparing',
    },
    button: {
      translation: 'global.status.preparing.button',
      defaultMessage: 'Continue',
    },
  },
  rejected: {
    className: 'error',
    text: {
      translation: 'global.status.rejected',
      defaultMessage: 'Rejected',
    },
    button: {
      translation: 'global.status.rejected.button',
      defaultMessage: 'View',
    },
  },
  ready_file: {
    className: 'success',
    text: {
      translation: 'global.status.ready-to-file',
      defaultMessage: 'Ready to File',
    },
    button: {
      translation: 'global.status.ready-to-file.button',
      defaultMessage: 'Mark as Filed',
    },
  },
  filed: {
    className: 'success',
    text: {
      translation: 'global.status.filed',
      defaultMessage: 'Filed',
    },
    button: {
      translation: 'global.status.filed.button',
      defaultMessage: 'View',
    },
  },
  awaiting_review: {
    className: 'grey',
    text: {
      translation: 'global.status.awaiting-review',
      defaultMessage: 'Awaiting Review',
    },
    button: {
      translation: 'global.status.awaiting-review.button',
      defaultMessage: 'Review',
    },
  },
  processing_errors: {
    className: 'error',
    text: {
      translation: 'global.status.processing-errors',
      defaultMessage: 'Processing Error',
    },
    button: {
      translation: 'global.status.processing-errors.button',
      defaultMessage: 'View',
    },
  },
  client_approval_pending: {
    className: 'success',
    text: {
      translation: 'global.status.client-approval-pending',
      defaultMessage: 'Client Approval Pending',
    },
    button: {
      translation: 'global.status.filed.button',
      defaultMessage: 'View',
    },
  },
  filing_rejected: {
    className: 'error',
    text: {
      translation: 'global.status.filing-rejected',
      defaultMessage: 'Filing Rejected',
    },
    button: {
      translation: 'global.status.filed.button',
      defaultMessage: 'View',
    },
  },
  data_rejected: {
    className: 'warnings',
    text: {
      translation: 'global.status.data-rejected',
      defaultMessage: 'Data Rejected',
    },
    button: {
      translation: 'global.status.filed.button',
      defaultMessage: 'View',
    },
  },
  sent_for_filing: {
    className: 'success',
    text: {
      translation: 'global.status.sent-for-filing',
      defaultMessage: 'Sent for filing',
    },
    button: {
      translation: 'global.status.payment-due.button',
      defaultMessage: 'Upload',
    },
  },
  payment_due: {
    className: 'warnings',
    text: {
      translation: 'global.status.payment-due',
      defaultMessage: 'Payment due',
    },
    button: {
      translation: 'global.status.payment-due.button',
      defaultMessage: 'Upload',
    },
  },
  payment_clearance: {
    className: 'warnings',
    text: {
      translation: 'global.status.payment-clearance',
      defaultMessage: 'Payment Clearance',
    },
    button: {
      translation: 'global.status.payment-clearance.button',
      defaultMessage: 'Tax Office Reference',
    },
  },
  payment_rejected: {
    className: 'warnings',
    text: {
      translation: 'global.status.payment-rejected',
      defaultMessage: 'Payment Rejected',
    },
    button: {
      translation: 'global.status.payment-rejected.button',
      defaultMessage: 'Payment Rejected',
    },
  },
};

/**
 * Status values for data in redux stores
 */
export const STATUS = {
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success',
  UPDATING: 'updating',
} as const;
